<template>
    <div>
        <v-row align="center">
            <v-col cols="2">
                <v-select
                    v-model="selectedTab"
                    :items="tabItems"
                    dense
                    outlined
                    hide-details
                    @change="changeTab"
                    style="min-width: 220px"
                />
            </v-col>
            <v-col cols="12">
                <ComponentThresholdConfig :selectedTab="selectedTab" />
            </v-col>
            <v-col cols="12">
                <ComponentWhitelistConfig :selectedTab="selectedTab" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { snackbar } from "@components/mixins/snackbar";
import { permission } from "@components/mixins/permission";
import ComponentThresholdConfig from "./ComponentThresholdConfig.vue";
import ComponentWhitelistConfig from "./ComponentWhitelistConfig.vue";

export default {
    mixins: [permission, snackbar],
    components: { ComponentThresholdConfig, ComponentWhitelistConfig },
    data() {
        return {
            tabNames: [
                "Fast Trade",
                "High Volume USD",
                "High Trades",
                "Large PNL",
                "Low Liquidity Arbitrage",
            ],
            selectedTab: "",
        };
    },
    computed: {
        tabItems() {
            return this.tabNames.map((t) => ({
                text: this.$t("profile.alert." + t.replaceAll(" ", "")),
                value: t,
            }));
        },
    },
    methods: {
        changeTab(name) {
            this.selectedTab = name;
        },
    },
    mounted() {
        this.changeTab(this.tabNames[0]);
    },
};
</script>
